<template>
    <div id="user" class="user">
        <router-view></router-view>
    </div>
</template>

<script>
    const log = new Log("Page/user");
    export default {
        name: "user"
    }
</script>

<style lang="less">
    #user {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 10px 0;
        border-radius: 5px;
        background-color: #ffffff
    }
</style>